module.exports = __webpack_public_path__ + "img/news-8.d53bde51.jpg";